import { formatDateMoment, getSelectedOption, setCurrency, setNumberWithPoint } from 'utils/utils'
import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import { Badge, Button } from 'avo-ui'
import { ACTION_TYPE } from 'constants/constant'
import { TYPE_BENEFIT } from 'configs/loyalty-program/configFormBenefitRedeemPoint'

export const TABLE_BENEFIT_REDEEM_POINT = {
    name: 'Benefit Redeem Point',
    column: [
        {
            name: 'Nama',
            key: 'name',
            className: 'capitalize',
        },
        {
            name: 'Type',
            key: 'type',
            className: 'capitalize',
            render: ({ value }) => <div>{getSelectedOption(TYPE_BENEFIT, value)?.label}</div>,
        },
        {
            name: 'Benefit',
            key: 'benefit',
            render: ({ item }) => (
                <div>
                    {item?.benefit?.id
                        ? `${item?.benefit?.name} - ${setNumberWithPoint(item?.benefit?.quantity)} pcs`
                        : setCurrency(item?.benefit?.discount_amount)}
                </div>
            ),
        },
        {
            name: 'Nilai Penukaran',
            key: 'point_needed',
            render: ({ value }) => <div>{value >= 0 ? `${setNumberWithPoint(value)} Point` : '-'}</div>,
        },
        {
            name: 'Masa Berlaku',
            key: 'date',
            render: ({ item }) => (
                <div>{`${formatDateMoment(item?.start_date, 'DD/MM/YYYY')} - ${formatDateMoment(item?.end_date, 'DD/MM/YYYY')}`}</div>
            ),
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button
                    type={'outline'}
                    title={'Edit'}
                    icon={icEditYellow}
                    onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                />
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}

export const INIT_FILTER = {
    types: [],
    statuses: [],
}

export const FILTER_BENEFIT_REDEEM_POINT = [
    {
        title: 'Tipe Benefit',
        key: 'types',
        list: TYPE_BENEFIT?.map((item) => {
            return { ...item, name: item?.label }
        }),
    },
    {
        title: 'Status',
        key: 'statuses',
        list: [
            {
                name: 'Active',
                value: 'active',
            },
            {
                name: 'Inactive',
                value: 'inactive',
            },
        ],
    },
]
